import { inject } from 'aurelia-framework';
import { SalesForecastService } from 'pages/sales-forecast/service';
import { DialogService } from 'aurelia-dialog';

import 'pages/sales-forecast/styles.scss';

@inject(SalesForecastService, DialogService)
export class SalesForecast {
  constructor(salesForecastService, dialogService) {
    this.salesForecastService = salesForecastService;
    this.dialogService = dialogService;

    this.dates = [];
  }

  async activate() {
    await this.loadData();
  }

  async loadData() {
    this.monthlyVolume = await this.salesForecastService.getCurrent();
    if (this.monthlyVolume.length > 0) {
      this.dates = this.monthlyVolume[0].monthlyVolumes;
    }
  }

  getVolume(item, date) {
    const volume = item.monthlyVolumes.find(d => d.month === date.month && d.year === date.year);
    return volume ? volume.volume : 0;
  }

  async updateVolume(item, date, volume, inputElement) {
    const volumeItem = item.monthlyVolumes.find(d => d.month === date.month && d.year === date.year);
    await this.salesForecastService.updateVolume(volumeItem.id, volume);
    // Add flash animation
    if (inputElement) {
      inputElement.classList.add('flash-animation');
      setTimeout(() => {
        inputElement.classList.remove('flash-animation');
      }, 500);
    }
  }

  importMonthlyVolume() {
    this.dialogService.open({ viewModel: PLATFORM.moduleName('pages/sales-forecast/import/index') }).whenClosed(async response => {
      if (!response.wasCancelled) {
        await this.loadData();
      }
    });
  }

  async exportSalesForecast() {
    this.dialogService.open({ viewModel: PLATFORM.moduleName('pages/sales-forecast/export/index') }).whenClosed(async response => {
      if (!response.wasCancelled) {
        // Handle export logic here if needed
      }
    });
  }
}